import React, { useState, useEffect } from 'react';
import '../styles/Header.css';
import logo from '../assets/images/haroSilver.png';
import { Link, useNavigate } from 'react-router-dom';
import MarqueeBanner from './MarqueeBanner';

const Header = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMenuActive) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isMenuActive]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuClick = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleNavLinkClick = () => {
    setIsMenuActive(false);
  };

  const scrollToSection = (sectionId) => {
    handleNavLinkClick();
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleWhatsAppRedirect = () => {
    const phoneNumber = '917019272992';
    const message = "Hi, I'm interested in purchasing your products. Could you please share more details?"
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank'); // Opens WhatsApp in new tab
  };


  const goToSectionProduct = () => {
    navigate('/', { state: { scrollToId: 'productFilter' } });
     setIsMenuActive(false);
  };
  const goToSectionHome = () => {
    navigate('/', { state: { scrollToId: 'homeBannerHaro' } });
     setIsMenuActive(false);
  };

    const gallerySection = () => {
    navigate('/', { state: { scrollToId: 'gallerysection' } });
     setIsMenuActive(false);
  };

  return (
    <>
      <MarqueeBanner />
      <header className="headerContainer">
        <nav className={`navbarHaro ${isScrolled ? 'scrolled' : ''}`}>
          <a  className="nav-link logo" onClick={goToSectionHome}>
            <div className="logo-icon">
              <img src={logo} alt="logo" />
            </div>
          </a>

          <ul className={`nav-links ${isMenuActive ? 'active' : ''}`}>
            <li>
              <a onClick={goToSectionHome} className='productsLinksNav'>
                Home
              </a>
            </li>
            <li>
              <a onClick={goToSectionProduct} className='productsLinksNav'>
                Products
              </a>
            </li>
            <li>
              <a onClick={gallerySection} className='productsLinksNav'>
                Gallery
              </a>
            </li>
            <li>
              <Link to="/about-us" onClick={handleNavLinkClick}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact-us" onClick={handleNavLinkClick}>
                Contact Us
              </Link>
            </li>
          </ul>
          <button onClick={handleWhatsAppRedirect} className="cta-button">Order Now</button>
          <div className="menu-btn" id="menuBtn" onClick={handleMenuClick}>
            <div className="menu-icon">
              {isMenuActive ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
